module.exports = __webpack_public_path__ + "img/bg_video3.bd295776.png";